import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import Datepicker from 'vuejs-datepicker'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'

import BoardForm from './board-form.js'

import AddBoard from './components/addboard/addboard.vue'
import AddEmployee from './components/addemployee/addemployee.vue'
import BoardDetails from './components/boarddetails/boarddetails.vue'
import BoardHistory from './components/history/boardhistory.vue'
import DisapprovalModal from './components/modal/disapprovalmodal.vue'

import EmployeeBoardRepository from '@/shared/http/repositories/business/employeeboard'
import EmployeeBoardItemRepository from '@/shared/http/repositories/business/employeeboarditem'
import EmployeeBoardHistoryRepository from '@/shared/http/repositories/business/employeeboardhistory'
import EmployeeboardMixin from '@/store/module/employeeboard/mixin'
import { actionTypes as EmployeeboardActions } from '@/store/module/employeeboard/actions'

export default {
  name: 'board',
  mixins: [ ActionsForm, EmployeeboardMixin ],
  data () {
    return {
      data: null,
      form: BoardForm,
      en: en,
      es: es,
      ptBR: ptBR,
      hasNewBoard: false,
      hasNewEmployee: false,
      hasBoard: false,
      objSelected: null,
      showHistory: false,
      dataHistory: null,
      showModal: false,
      totalRefeicaoQuantidade: 0,
      totalRefeicaoValorUnitario: 0,
      totalValeAlimentacao: 0,
      totalCafeManhaValor: 0,
      totalValeTransporteQuantidade: 0,
      totalValeTransporteValorUnitario: 0,
      order: 1
    }
  },
  components: {
    Datepicker,
    AddBoard,
    AddEmployee,
    BoardDetails,
    BoardHistory,
    DisapprovalModal
  },
  computed: {
    canNewEmployee () {
      var result = false
      if (this.objSelected && this.objSelected.situacao === 0) {
        result = true
      }
      return result
    },
    hasActionsButtons () {
      var result = false
      if (this.objSelected && this.objSelected.situacao <= 0) {
        result = true
      }
      return result
    }
  },
  created () {
    this.onEditEmployeeBoard(this.objSelected)
  },
  methods: {
    onClear () {},
    onLoad () {
      if (this.objSelected) {
        this.onLoadItems(this.objSelected.id)
      }
    },
    onChangePagingLimit (pagingLimit) {
      this[EmployeeboardActions.GET_PAGING_LIMIT](pagingLimit)
    },
    onEdit (obj) {
      if (this.objSelected.situacao <= 0) {
        this.onAddEmployee()
        this.$nextTick(() => {
          this.$refs.AddEmployee.onEdit(obj)
        })
      } else {
        toast.warning(this.$lang.EmployeeBoard.Board.ClosedBoard)
      }
    },
    onAddBoard () {
      this.objSelected = null
      this.objList = []
      this.hasNewBoard = true
      this.$nextTick(() => {
        this.$refs.AddBoard.onClear()
      })
    },
    onBackAddBoard (obj) {
      this.hasNewBoard = false
      if (obj) {
        this.hasBoard = true
        this.objSelected = obj
        this.onLoad()
      }
    },
    onEditBoard (obj) {
      this.hasNewBoard = true
      this.$nextTick(() => {
        this.$refs.AddBoard.onEdit(obj)
      })
    },
    onDeleteBoard (obj) {
      this.hasNewBoard = false
      this.objSelected = null
      this.objList = null
      this.$emit('Delete', obj)
    },
    onAddEmployee () {
      this.hasNewEmployee = true
      this.$nextTick(() => {
        this.$refs.AddEmployee.objSelected = this.objSelected
        this.$refs.AddEmployee.onClear()
      })
    },
    onBackAddEmployee () {
      this.hasNewEmployee = false
      this.$nextTick(() => {
        this.onLoadItems(this.objSelected.id)
      }
      )
    },
    onEditEmployeeBoard (obj) {
      if (obj) {
        this.hasBoard = true
        this.hasNewBoard = false
        this.hasNewEmployee = false
        this.objSelected = obj
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadItems(obj.id)
          this.$refs.BoardDetails.showObservations = false
        })
      }
    },
    onSearch () {
      this.onLoadItems(this.objSelected.id)
    },
    onLoadItems (boardID) {
      if (boardID) {
        loading.push()
        EmployeeBoardItemRepository.GetAllPaging(boardID, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, this.order === 1 ? 'codigo' : 'nome', 'ASC')
          .then(response => {
            if (response.data.code > 0) {
              this.onResultGrid(response)
              this.totalRefeicaoValorUnitario = response.data.totalRefeicaoValorUnitario
              this.totalRefeicaoQuantidade = response.data.totalRefeicaoQuantidade
              this.totalValeAlimentacao = response.data.totalValeAlimentacao
              this.totalCafeManhaValor = response.data.totalCafeManhaValor
              this.totalValeTransporteQuantidade = response.data.totalValeTransporteQuantidade
              this.totalValeTransporteValorUnitario = response.data.totalValeTransporteValorUnitario
            }
          })
          .catch(this.onException)
      }
    },
    onOrder (order) {
      this.order = order
      this.onLoadItems(this.objSelected.id)
    },
    onDelete (obj) {
      loading.push()
      EmployeeBoardItemRepository.Delete(obj.id)
        .then((response) => {
          loading.close()
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
            if (this.objSelected) {
              this.onLoadItems(this.objSelected.id)
            }
          }
        })
        .catch(this.onException)
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onSectionApproval (obj) {
      if (obj) {
        loading.push()
        obj.situacao = 1
        EmployeeBoardRepository.Update(obj)
          .then((response) => {
            if (response.data.code >= 0) {
              this.onCreateHistory(obj, this.getStageHistory(obj.situacao))
              loading.close()
              this.objSelected = obj
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    onApproval (obj) {
      if (obj) {
        loading.push()
        obj.situacao = parseInt(obj.situacao) + 1
        EmployeeBoardRepository.Update(obj)
          .then((response) => {
            if (response.data.code >= 0) {
              this.onCreateHistory(obj, this.getStageHistory(obj.situacao))
              loading.close()
              this.objSelected = obj
              toast.success(this.$lang.Common.Alerts.Success)
            }
          })
          .catch(this.onException)
      }
    },
    onDisapproval (obj) {
      if (obj) {
        this.objSelected = obj
        this.$refs.DisapprovalModal.showModal()
      }
    },
    onDisapprovalSave (reason) {
      loading.push()
      this.objSelected.situacao = -this.objSelected.situacao
      EmployeeBoardRepository.Update(this.objSelected)
        .then((response) => {
          if (response.data.code >= 0) {
            this.onCreateHistory(this.objSelected, this.getStageHistory(this.objSelected.situacao), reason)
            loading.close()
            toast.success(this.$lang.Common.Alerts.Success)
          }
        })
        .catch(this.onException)
    },
    onHistory () {
      this.showHistory ? this.showHistory = false : this.showHistory = true
      if (this.showHistory) {
        this.onLoadHistory()
      }
    },
    onLoadHistory () {
      if (this.objSelected) {
        loading.push()
        EmployeeBoardHistoryRepository.GetAll(this.objSelected.id)
          .then((response) => {
            if (response.data.code >= 0) {
              this.dataHistory = response.data.data
              loading.close()
            }
          })
          .catch(this.onException)
      }
    },
    onCreateHistory (obj, action, reason) {
      let result = false
      const history = {
        quadroFuncionarioID: obj.id,
        autorID: obj.contaIDAcao,
        dataCriacao: obj.dataAcao,
        ip: this.ip,
        latitude: this.latitude ? this.latitude.toString() : '',
        longitude: this.longitude ? this.longitude.toString() : '',
        acao: action,
        observacaoMotivo: reason != null ? reason : '',
        status: 1
      }
      EmployeeBoardHistoryRepository.Create(history)
        .then((response) => {
          if (response.data.code >= 0) {
            result = true
          }
        })
        .catch(this.onException)
      return result
    },
    getStageHistory (stage) {
      let result = ''
      if (stage) {
        switch (parseInt(stage)) {
          case 1: result = 'ENVIO PARA APROVAÇÃO COORDENADOR REGIONAL'
            break
          case 2: result = 'REGIONAL APROVOU'
            break
          case 3: result = 'RH APROVOU'
            break
          case -1: result = 'REGIONAL REPROVOU'
            break
          case -2: result = 'RH REPROVOU'
            break
        }
      }
      return result
    },
    onPrint () {
      loading.push()
      EmployeeBoardRepository.Print([this.objSelected.id])
        .then((response) => {
          if (response.data.code > 0) {
            let pdfWindow = window.open('Quadro.pdf')
            let pdf = encodeURI(response.data.data)
            pdfWindow.document.write(`
              <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
            `)
          }
        })
        .catch(this.onException)

      loading.close()
    },
    onClone () {
      if (this.objSelected) {
        loading.push()
        this.order = 1
        EmployeeBoardRepository.Clone(this.objSelected.id)
          .then((response) => {
            if (response.data.code >= 0) {
              var obj = response.data.data
              this.onCloneItem(this.objSelected, response.data.data)
              this.onCreateHistory(obj, 'CRIOU O QUADRO (CLONE)', 'REF. CLONE: ' + this.objSelected.id)
              this.objSelected = obj
              // this.onLoadItems(this.objSelected.id)
              loading.close()
              toast.success(this.$lang.Common.Alerts.Success)
            } else {
              loading.close()
              toast.error(this.$lang.EmployeeBoard.Board.CouldNotClone)
            }
          })
          .catch(this.onException)
      }
    },
    onCloneItem (objOld, objNew) {
      EmployeeBoardItemRepository.Clone(objOld.id, objNew.id)
        .then((response) => {
          if (response.data.code >= 0) {
            this.onLoadItems(objNew.id)
            toast.success(this.$lang.Common.Alerts.Success)
          } else {
            toast.error(this.$lang.EmployeeBoard.Board.CouldNotClone)
          }
        })
    },
    onExport (exportObj) {
      loading.push()
      EmployeeBoardItemRepository.GetAll(this.objSelected.id)
        .then(response => {
          loading.close()
          if (response.data.code > 0) {
            const text = []
            response.data.data.forEach(employee => {
              if (exportObj.eventFood) {
                text.push(`${employee.funcionario.codigo.toString().padStart(5, '0')}${exportObj.eventFood.padStart(5, '0')}${parseInt(employee.valeAlimentacao * 100).toString().padStart(5, '0')}\n`)
              }
              if (exportObj.eventMeal) {
                text.push(`${employee.funcionario.codigo.toString().padStart(5, '0')}${exportObj.eventMeal.padStart(5, '0')}${parseInt(employee.refeicaoQuantidade * employee.refeicaoValorUnitario * exportObj.days * 100).toString().padStart(5, '0')}\n`)
              }
              if (exportObj.eventBreakfest) {
                text.push(`${employee.funcionario.codigo.toString().padStart(5, '0')}${exportObj.eventBreakfest.padStart(5, '0')}${parseInt(employee.cafeManhaValor * 100).toString().padStart(5, '0')}\n`)
              }
              if (exportObj.eventLunch) {
                text.push(`${employee.funcionario.codigo.toString().padStart(5, '0')}${exportObj.eventLunch.padStart(5, '0')}${parseInt(employee.cafeManhaValor * exportObj.days * 100).toString().padStart(5, '0')}\n`)
              }
              if (exportObj.eventTransport) {
                text.push(`${employee.funcionario.codigo.toString().padStart(5, '0')}${exportObj.eventTransport.padStart(5, '0')}${parseInt(employee.valeTransporteQuantidade * employee.valeTransporteValorUnitario * exportObj.days * 100).toString().padStart(5, '0')}\n`)
              }
            })
            const fileName = 'QuadroFuncionario.txt'
            const properties = { type: 'text/plain' }
            const file = new File(text, fileName, properties)
            const url = URL.createObjectURL(file)
            const ref = document.createElement('a')
            ref.href = url
            ref.download = fileName
            ref.click()
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/employeeboard/board/board.js